export default {
  PLUGIN_NAME: 'Youtube',
  PLUGIN_TYPE: 'youtube',
};
